import { observer } from 'mobx-react-lite';
import Popup from '../../../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../../../hooks/useStore';
import { Form, Formik } from 'formik';
import CommonButton from '../../../../../../components/common-components/button/CommonButton';
import { FormikTextField } from '../../../../../../components/form-components/common-components/text-field/FormikTextField';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import styles from './NewTagNumber.module.css';

import { useMemo } from 'react';
import { useEffect } from 'react';
import CommonDropdown from '../../../../../../components/common-components/dropdown/CommonDropdown';
import { IHospitalResult } from '../../../../../../models/hospital/HospitalModel';

const validationSchema = Yup.object({
  hospitalId: Yup.number().required('Hastane seçimi zorunludur'),
  prefix: Yup.string().required('Ön ek zorunludur').min(1, 'Ön ek en az 1 karakter olmalıdır'),
});

const initialValues = {
  hospitalId: null as number | null,
  prefix: '',
};

const NewTagNumber = () => {
  const { popupStore, hospitalStore, hospitalFilesStore, uiStore } = useStore();

  useEffect(() => {
    hospitalStore.listAllHospitals();
  }, [hospitalStore]);

  const hospitalOptions: { value: number; label: string }[] = useMemo(
    () =>
      hospitalStore.hospitalList
        .filter(
          (hospital): hospital is IHospitalResult & { id: number; hospitalName: string } =>
            hospital.id !== undefined && hospital.hospitalName !== undefined
        )
        .map(hospital => ({
          value: hospital.id,
          label: hospital.hospitalName,
        })),
    [hospitalStore.hospitalList]
  );

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      if (!values.hospitalId) {
        toast.error('Lütfen bir hastane seçiniz');
        return;
      }

      uiStore.setLoading(true);
      const response = await hospitalFilesStore.addHospitalTagPrefix({
        hospitalId: values.hospitalId,
        prefix: values.prefix,
      });
      if (response.error != true) {
        toast.success('Ön ek başarıyla eklendi');
        popupStore.setIsNewTagOpen(false);
      }
      if (response.error == true) {
        toast.error('Ön ek eklenirken bir hata oluştu : ' + response.message);
      }
    } catch (error) {
      console.error('Prefix eklenirken hata:', error);
      toast.error('Ön ek eklenirken bir hata oluştu');
    } finally {
      uiStore.setLoading(false);
    }
  };

  const handleClose = () => {
    popupStore.setIsNewTagOpen(false);
    toast.dismiss();
  };

  return (
    <Popup isOpen={popupStore.isNewTagOpen} onClose={handleClose} title="Hastane Etiket No Ekle">
      <div className={styles.container}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <Form className={styles.form}>
              <div className={styles.inputContainer}>
                <CommonDropdown<number>
                  options={hospitalOptions}
                  value={values.hospitalId}
                  onChange={value => setFieldValue('hospitalId', value)}
                  label="Hastane Seçiniz"
                  placeholder="Hastane seçin"
                />
              </div>

              <div className={styles.inputContainer}>
                <FormikTextField name="prefix" label="Ön Ek" placeholder="Ön ek giriniz" />
              </div>

              <div className={styles.buttonContainer}>
                <CommonButton
                  type="primary"
                  disabled={isSubmitting}
                  loading={uiStore.isLoading}
                  className={styles.submitButton}
                >
                  Kaydet
                </CommonButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Popup>
  );
};

export default observer(NewTagNumber);
